import { postPlanSchema } from "./post-plan.schema";

const patchPlanSchema = postPlanSchema;

export { patchPlanSchema };
